 // ! TODO: move this to `components`
import React, { ReactNode } from 'react';

import { Link as RouterLink } from 'react-router-dom';
import queryString from 'query-string';

import { Flex } from '@waglabs/flex-next';
import Link from '@waglabs/link';
import { Typography } from '@waglabs/typography';

import {
  ROUTE_LOGIN,
  WAGWALKING_URL,
} from '../../../../constants';

import {
  withHistory,
  WithHistoryInjectedProps,
} from '../../../../hocs';

import LogoText from '../../../../assets/svg/LogoText';

type SignUpHeaderProps = WithHistoryInjectedProps & {
  children?: ReactNode;
};

const getLoginUrl = (search: string) => queryString.stringifyUrl({
  url: ROUTE_LOGIN,
  query: queryString.parse(search),
});

const SignUpHeader = ({
  history: {
    location: {
      search,
    },
  },
  children,
}: SignUpHeaderProps) => (
  <Flex
    alignItems="center"
    justifyContent="space-between"
    pb={1}
    pt={2}
    px={2}
  >
    <Link
      href={WAGWALKING_URL}
    >
      <LogoText
        width="80px"
      />
    </Link>

    {children || (
      <RouterLink
        to={getLoginUrl(search)}
      >
        <Typography
          color="wagGreen"
          hover
          variant="body2"
        >
          My account
        </Typography>
      </RouterLink>
    )}
  </Flex>
);

const SignUpHeaderWithHistory = withHistory(SignUpHeader);
export {
  SignUpHeaderWithHistory as SignUpHeader,
};
